import { render, staticRenderFns } from "./results.vue?vue&type=template&id=257e8252&"
import script from "./results.vue?vue&type=script&lang=js&"
export * from "./results.vue?vue&type=script&lang=js&"
import style0 from "./results.vue?vue&type=style&index=0&id=257e8252&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports